import axios from 'axios'
import { API_URL } from '../../config/apiConfig';
import { combineEpics, Epic } from 'redux-observable'
import { catchError, filter, map, mergeMap, startWith, switchMap } from 'rxjs/operators'
import {
  addedContacts,
  addingContacts,
  addingContactsFailed,
  ContactsAction,
  ContactsActionTypes,
  editedContacts,
  editingContacts,
  editingContactsFailed,
  foundContacts,
  loadedContacts,
  loadingContacts,
  loadingContactsFailed,
  removedContact,
  removingContact,
  removingContactFailed,
  searchingContacts,
  searchingContactsFailed,
  softRemovedContacts,
  softRemovingContacts,
  softRemovingContactsFailed,
} from '../actions/contactsActions'
import buildFormData from './buildFormData'

import { from, of } from 'rxjs'
import { isOfType } from 'typesafe-actions'
import { IState } from '../reducers'


const searchContactsEpic: Epic<ContactsAction, ContactsAction, IState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(ContactsActionTypes.SEARCH_CONTACTS)),
    mergeMap((action) => {
      if (typeof action.searchOptions === 'string') {
        action.searchOptions = {
          searchString: action.searchOptions,
          page: 1,
          searchField: '_id',
        }
      }
      let url = `${API_URL}/api/contacts/search/`
      return from(axios.get(url, { params: action.searchOptions })).pipe(
        map((response) => foundContacts(response.data, action.keep)),
        startWith(searchingContacts()),
        catchError(() => of(searchingContactsFailed()))
      )
    })
  )

const loadContactsEpic: Epic<ContactsAction, ContactsAction, IState> = (action$, state$) => {
  let responses = []
  return action$.pipe(
    filter(isOfType(ContactsActionTypes.LOAD_CONTACTS)),
    switchMap((action) => {
      let url = `${API_URL}/api/contacts/`
      return from(axios.get(url, { params: action.loadOptions })).pipe(
        map((response) => loadedContacts(response.data)),
        startWith(loadingContacts()),
        catchError(() => of(loadingContactsFailed()))
      )
    })
  )
}

const addContactsEpic: Epic<ContactsAction, ContactsAction, IState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(ContactsActionTypes.ADD_CONTACTS)),

    mergeMap((action) => {
      const data = new FormData()
      buildFormData(data, action.payload)
      const config = {
        headers: {
          'content-type': 'multipart/form-data',
        },
      }

      return from(axios.post(`${API_URL}/api/contacts/`, data, config)).pipe(
        map((response) => addedContacts(response.data)),
        startWith(addingContacts()),
        catchError((err) => of(addingContactsFailed(err.response)))
      )
    })
  )

const removeContactsEpic: Epic<ContactsAction, ContactsAction, IState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(ContactsActionTypes.REMOVE_CONTACT)),
    mergeMap((action) =>
      from(axios.delete(`${API_URL}/api/contacts/${action.payload._id}`)).pipe(
        map((response) => removedContact()),
        startWith(removingContact()),
        catchError(() => of(removingContactFailed()))
      )
    )
  )

const softRemoveContactsEpic: Epic<ContactsAction, ContactsAction, IState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(ContactsActionTypes.SOFT_REMOVE_CONTACTS)),
    mergeMap((action) =>
      from(axios.delete(`${API_URL}/api/contacts/soft/${action.payload._id}`)).pipe(
        map((response) => softRemovedContacts(response.data.record)),
        startWith(softRemovingContacts()),
        catchError((err) => of(softRemovingContactsFailed(err.response)))
      )
    )
  )

const editContactsEpic: Epic<ContactsAction, ContactsAction, IState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(ContactsActionTypes.EDIT_CONTACTS)),
    mergeMap((action) => {
      const data = new FormData()
      buildFormData(data, action.payload)
      const config = {
        headers: {
          'content-type': 'multipart/form-data',
        },
      }

      return from(axios.put(`${API_URL}/api/contacts/${action.payload._id}`, data, config)).pipe(
        map((response) => editedContacts(response.data)),
        startWith(editingContacts()),
        catchError((err) => of(editingContactsFailed(err.response)))
      )
    })
  )

export default combineEpics(searchContactsEpic, loadContactsEpic, addContactsEpic, removeContactsEpic, softRemoveContactsEpic, editContactsEpic)
